class UndoneAction {
    constructor(previousState, newState, undoAction, redoAction) {
        this.previousState = previousState;
        this.newState = newState;
        this.undoAction = undoAction;
        this.redoAction = redoAction;
    }
}

export default UndoneAction;